
<template>
  <div>
    <div
      class="wordCloud__tagBall"
      :style="{width:`${this.width}px`,height:`${this.height}px`}"
    >
      <span
        class="wordCloud__tag"
        v-for="(item, index) of cities"
        :key="index"
        :style="{color:color[index % color.length],...contentEle[index].style}"
        @click="selectCity(item)"
      >{{item}}</span>
    </div>

    <!-- <div class="wordCloud__home">
      <el-button
        type="danger"
        @click="handleSpeed('slow')"
      >降低速度</el-button>
      <el-button
        type="primary"
        @click="handleRotate('-1')"
      >横向顺时针</el-button>
      <el-button
        type="primary"
        @click="handleRotate('1')"
      >横向逆时针</el-button>
      <el-button
        type="primary"
        @click="handleRotate('-2')"
      >纵向顺时针</el-button>
      <el-button
        type="primary"
        @click="handleRotate('2')"
      >纵向逆时针</el-button>
      <el-button
        type="danger"
        @click="handleSpeed('fast')"
      >增加速度</el-button>
    </div> -->
  </div>
</template>

<script>
export default {
  name: 'ThreeDWordCloud',
  props: {
    cities: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    color: ['#2D4DB6', '#04B67C', '#D1AF07', '#E27914', '#CB4A4D', '#B02690'],
    contentEle: [],
    width: 500,
    height: 500,
    direction: '-1',
    speed: 400,
    originalSpeed: 400,
    isSpeedRotating: false,
    isAnimating: true // 新增：控制是否进行动画
  }),
  watch: {
    cities: {
      handler() {
        this.initializeWordCloud()
      },
      immediate: true
    }
  },
  mounted() {
    this.initializeWordCloud()
  },
  methods: {
    initializeWordCloud() {
      if (this.cities && this.cities.length > 0) {
        this.contentEle = this.cities.map(() => ({
          x: 0,
          y: 0,
          z: 0,
          style: {}
        }))
        this.innit()
      }
    },
    selectCity(cityName) {
      // 只有在非加速旋转状态下才允许点击选择城市
      if (!this.isSpeedRotating) {
        this.$emit('city-selected', cityName)
      }
    },
    innit() {
      const RADIUSX = (this.width - 50) / 2
      const RADIUSY = (this.height - 50) / 2
      this.contentEle = []
      for (let i = 0; i < this.cities.length; i += 1) {
        const k = -1 + (2 * (i + 1) - 1) / this.cities.length
        const a = Math.acos(k)
        const b = a * Math.sqrt(this.cities.length * Math.PI)
        const x = RADIUSX * Math.sin(a) * Math.cos(b)
        const y = RADIUSY * Math.sin(a) * Math.sin(b)
        const z = RADIUSX * Math.cos(a)
        const singleEle = {
          x,
          y,
          z,
          style: {}
        }
        this.contentEle.push(singleEle)
      }
      // 初始化时只渲染一次位置，不开始动画
      this.animate()
    },
    animate() {
      if (!this.isAnimating) return // 如果不需要动画，直接返回
      
      this.rotateX();
      this.rotateY();
      this.move();
      window.requestAnimationFrame(this.animate);
    },
    startSpeedRotation() {
      this.isSpeedRotating = true
      this.isAnimating = true // 开始动画
      this.originalSpeed = this.speed
      this.speed = 50 // 加速旋转
      this.direction = '1' // 设置旋转方向
      this.animate() // 开始动画循环
    },
    stopSpeedRotation() {
      this.isSpeedRotating = false
      this.isAnimating = false // 停止动画
      this.speed = this.originalSpeed // 恢复原始速度
    },
    rotateX() {
      const angleX = ['-1', '1'].includes(this.direction)
        ? Math.PI / Infinity
        : Math.PI / ((Number(this.direction) / 2) * Number(this.speed));
      const cos = Math.cos(angleX);
      const sin = Math.sin(angleX);
  
      this.contentEle = this.contentEle.map((t) => {
        const y1 = t.y * cos - t.z * sin;
        const z1 = t.z * cos + t.y * sin;
        return {
          ...t,
          y: y1,
          z: z1
        };
      });
    },
    rotateY() {
      const angleY = ['-2', '2'].includes(this.direction)
        ? Math.PI / Infinity
        : Math.PI / (Number(this.direction) * Number(this.speed));
      const cos = Math.cos(angleY);
      const sin = Math.sin(angleY);
      this.contentEle = this.contentEle.map((t) => {
        const x1 = t.x * cos - t.z * sin;
        const z1 = t.z * cos + t.x * sin;
        return {
          ...t,
          x: x1,
          z: z1
        };
      });
    },
    move() {
      const CX = this.width / 2;
      const CY = this.height / 2;
      this.contentEle = this.contentEle.map((singleEle) => {
        const { x, y, z } = singleEle;
        const fallLength = 500;
        const RADIUS = (this.width - 50) / 2;
        const scale = fallLength / (fallLength - z);
        const alpha = (z + RADIUS) / (2 * RADIUS);
        const left = `${x + CX - 15}px`;
        const top = `${y + CY - 15}px`;
        const transform = `translate(${left}, ${top}) scale(${scale})`;
        const style = {
          ...singleEle.style,
          opacity: alpha + 0.5,
          zIndex: parseInt(scale * 100, 10),
          transform
        };
        return {
          x,
          y,
          z,
          style
        };
      });
    },
    handleRotate(value) {
      this.direction = value;
      // 手动控制旋转时也需要开启动画
      if (!this.isAnimating) {
        this.isAnimating = true;
        this.animate();
      }
    },
    handleSpeed(value) {
      const speedObj = {
        fast: -50,
        slow: 50
      };
      this.speed += speedObj[value];
      if (this.speed === 0) {
        this.speed = 50;
      }
      // 手动控制速度时也需要开启动画
      if (!this.isAnimating) {
        this.isAnimating = true;
        this.animate();
      }
    }
  }
}
</script>

<style lang="less" scoped>
.wordCloud__tagBall {
  margin: 50px auto;
  position: relative;
}

.wordCloud__tag {
  display: block;
  position: absolute;
  left: 0px;
  top: 0px;
  color: green;
  text-decoration: none;
  font-size: 15px;
  font-family: '微软雅黑';
  font-weight: bold;
  cursor: pointer;

  &:hover {
    color: red;
  }
}

.wordCloud__home {
  display: flex;
  justify-content: center;
}
</style>